import React from 'react';
import { FeatureSection as RawFeatureSection } from '../../../components/landingPage/FeatureSection';
import { SanityObject } from '../../../lib/landingPage';
import { FeatureCard, FeatureCardProps } from '../FeatureCard';
import { Wrapper } from '../Wrapper';

export type FeatureSectionProps = {
    features: SanityObject<FeatureCardProps>[];
    title: string;
    subtitle: string;
};

export const FeatureSection = Wrapper(
    ({ title, subtitle, features }: FeatureSectionProps): JSX.Element => {
        return (
            <RawFeatureSection title={title} subtitle={subtitle}>
                <FeatureCard value={features} />
            </RawFeatureSection>
        );
    },
    'featureSection'
);
